function eval_partials() {

    document.querySelectorAll('.partial').forEach(function($partial){
		if ($partial.querySelector('.link')) {
			var down;
			var $link = $partial.querySelector('.link');
			$partial.style.cursor = 'pointer';

			$partial.onmousedown = function() { down = +new Date(); }
			$partial.onmouseup = function(e) {
				// don't do anything if we're clicking the actual link
				if(e.target != $link) {
					var up = +new Date();
					if((up - down) < 200){
						if(e.button == 0) {
							if (e.metaKey) {
								window.open($link.href, '_blank');
							} else if (e.ctrlKey) {
								window.open($link.href, '_blank');
							} else if (e.shiftKey) {
								window.open($link.href);
							} else {
								$link.click();
							}
						} else if (e.button == 1) {
							var old_target = $link.getAttribute('target');
							$link.setAttribute('target','_blank');
							$link.click();
							$link.setAttribute('target',old_target);
						}
					}
				}
			}
			
		}
    });
}
// evaluate partials on page load
eval_partials();
